module.exports = __webpack_public_path__ + "fa-regular-400.ttf?22fdf9aabb1c98e043aacc09d9ebb4a3";